export enum MaintenanceJobTabReferrer {
  Details = 'details',
  SpareParts = 'spareParts',
  ProductTypes = 'productTypes',
  Log = 'log',
}
